
import { createWebHistory, createRouter } from "vue-router";
import Home from '../pages/Home.vue';
export const routes = [
    {
        path: '/',
        redirect: '/home', // Redirigir la raíz a /home
    },
    {
        name: 'home',
        path: '/home',
        component: Home,
        meta: { title: 'Bienvenido', requiresAuth: false },
    },
    {
        name: 'users',
        path: '/users',
        component: () => import(/* webpackChunkName: "UsersV041120251658" */'../components/Users'),
        meta: { title: 'Admin. Usuarios', requiresAuth: true, roles: ['admin'], permisos: ['users-read'] },
    },
    /*{
        name: 'register',
        path: '/register',
        component: () => import('../pages/Register'),
        meta: { title: 'Nuevo User', requiresAuth: true, roles: ['admin'] },
    },*/
    {
        name: 'Ingresa',
        path: '/Ingresa',
        component: () => import(/* webpackChunkName: "LoginV181220251140" */'../pages/Login'),
        meta: { title: 'Inicia Sesión' },
    },
    {
        name: 'dashboard',
        path: '/dashboard',
        component: () => import(/* webpackChunkName: "DashboardComponentV181220251140" */'../components/DashboardComponent'),
        meta: { title: 'Escritorio', requiresAuth: true, roles: ['cliente'] },
    },
    {
        name: 'contacto',
        path: '/Contacto',
        component: () => import(/* webpackChunkName: "ContactoEmpresaV181220251140" */'../components/navegation/ContactoEmpresa'),
        meta: { title: 'Contacto' }
    },
    {
        name: 'ProdsMX',
        path: '/ProdsMX',
        component: () => import(/* webpackChunkName: "prodmx" */'../components/navegation/prodmx'),
        meta: { title: 'Hechos en México' }
    },
    {
        name: 'OurBrands',
        path: '/OurBrands',
        component: () => import(/* webpackChunkName: "nuestrasmarcas" */'../components/navegation/nuestrasmarcas'),
        meta: { title: 'Nuestras Marcas' }
    },
    {
        name: 'posts',
        path: '/posts',
        component: () => import(/* webpackChunkName: "Posts" */'../components/Posts'),
        meta: { title: 'Admin. Banners', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'addpost',
        path: '/posts/add',
        component: () => import(/* webpackChunkName: "AddPostV020120261024" */'../components/AddPost'),
        meta: { title: 'Crear Banner', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'editpost',
        path: '/posts/edit/:id',
        component: () => import(/* webpackChunkName: "EditPostV020120261024" */'../components/EditPost'),
        meta: { title: 'Editar Banner', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'roles',
        path: '/roles',
        component: () => import(/* webpackChunkName: "rolesIndex" */'../Admin/roles/Index'),
        meta: { title: 'Index Roles', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'permisos',
        path: '/permisos',
        component: () => import(/* webpackChunkName: "permissionsindex" */'../Admin/permissions/index'),
        meta: { title: 'Index Permisos', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'editpermiso',
        path: '/permisos/edit/:id',
        component: () => import(/* webpackChunkName: "permissionsEdit" */'../Admin/permissions/Edit'),
        meta: { title: 'Edit Permisos', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'addPermisos',
        path: '/permisos/add',
        component: () => import(/* webpackChunkName: "permissionscreate" */'../Admin/permissions/create'),
        meta: { title: 'Add Permiso', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'addRole',
        path: '/roles/add',
        component: () => import(/* webpackChunkName: "permissionsAddRole" */'../Admin/roles/AddRole'),
        meta: { title: 'Add Rol', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'editrole',
        path: '/roles/edit/:id',
        component: () => import(/* webpackChunkName: "permissionsEditRole" */'../Admin/roles/EditRole'),
        meta: { title: 'Editar Rol', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'edituser',
        path: '/users/getPermissions/:id',
        component: () => import(/* webpackChunkName: "permissionsEditUser" */'../components/EditUser'),
        meta: { title: 'Editar Usuario', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'marcas',
        path: '/marcas',
        component: () => import(/* webpackChunkName: "marcas" */'../comunidad/marcas'),
        meta: { title: 'Nuestras Marcas' }
    },
    {
        name: 'excel',
        path: '/actualizarprods',
        component: () => import(/* webpackChunkName: "CargaProds" */'../components/UploadExcel/CargaProds'),
        meta: { title: 'Carga Productos', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'detalleProducto',
        path: '/detalleProducto',
        component: () => import(/* webpackChunkName: "vistaProds3V020120261642" */'../components/Prods/vistaProds3'),
        meta: { title: 'Detalle Producto' }

    }, 
    {
        name: 'Listayear',
        path: '/Listayear',
        component: () => import(/* webpackChunkName: "adminprods" */'../components/Prods/adminprods'),
        meta: { title: 'Admin Producto', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'addmarca',
        path: '/marca/add',
        component: () => import(/* webpackChunkName: "addMarca" */'../components/Prods/addMarca'),
        meta: { title: 'Agregar Marca', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'ListadoProds',
        path: '/ListaProds',
        component: () => import(/* webpackChunkName: "addMaProductosrca" */'../Admin/Productos/Productos'),
        meta: { title: 'Productos' }
    },
    {
        name: 'ListadoProductos',
        path: '/ListadoProductos',
        component: () => import(/* webpackChunkName: "ProductCard2V30011538" */'../components/viewsCart/ProductCard2'),
        meta: { title: 'Resultados' },
        props: route => ({
            busqueda: route.query.busqueda,
        })
    },
    {
        name: 'ListadoProductosLinea',
        path: '/ListadoProductosLinea',
        component: () => import(/* webpackChunkName: "ProductCardLineaV020120261605" */'../components/viewsCart/ProductCardLinea'),
        meta: { title: 'Resultados' }
    },
    {
        name: 'CatalogoListaProductos',
        path: '/catalogo/busqueda/:year/:marca/:modelo/:motor',
        component: () => import(/* webpackChunkName: "catalogoprods" */'../components/Prods/catalogoprods'),
        meta: { title: 'Busqueda por Catalogo' }
    },
    {
        name: 'listadocotizaciones',
        path: '/listadocotizaciones',
        component: () => import(/* webpackChunkName: "userpedidosV181220251140" */'../components/navegation/userpedidos'),
        meta: { title: 'List. Ped. No Auth.', requiresAuth: true, roles: ['cliente'] },
    },
    {
        name: 'listadocotizacionesaut',
        path: '/listadocotizacionesaut',
        component: () => import(/* webpackChunkName: "userpedidos2V140120261427" */'../components/navegation/userpedidos2'),
        meta: { title: 'List. Ped. Auth.', requiresAuth: true, roles: ['cliente'] },
    },
    {
        name: 'CartItemsList',
        path: '/CartItemsList',
        component: () => import(/* webpackChunkName: "ItemsCartList3V140120261643" */'../components/Prods/ItemsCartList3'),

        meta: { title: 'List. Prods. Cart.', requiresAuth: true, permisos: ['permission_compras'] },
    },
    {
        name: 'admindashboard',
        path: '/AdminDashboard',
        component: () => import(/* webpackChunkName: "dashboardAdminV041120251658" */'../Admin/dashboardAdmin'),
        meta: { title: 'Dashboard Admin', requiresAuth: true, roles: ['admin'], permisos: ['users-read', 'publicaciones-read'] },
    },
    {
        path: '/detalles-pedido',
        name: 'DetallesPedido',
        component: () => import(/* webpackChunkName: "DetallePedidoV191220251225" */ '../components/navegation/DetallePedido'),// Reemplaza con tu componente correspondiente
        meta: { title: 'Detalles Pedido', requiresAuth: true },
    },
    {
        path: '/Facturas',
        name: 'Facturas',
        component: () => import(/* webpackChunkName: "EnvoiceListV181220251140" */'../components/navegation/EnvoiceList'),// Reemplaza con tu componente correspondiente
        meta: { title: 'Detalles Pedido', requiresAuth: true },
    },
    {
        name: 'indicadores',
        path: '/Indicadores',
        component: () => import(/* webpackChunkName: "indicadores" */'../asesores/indicadores'),
        meta: { requiresAuth: true },
    }
    /*,
    {
        name: 'catalogoview',
        path: '/catalogoview/:year?/:categoria?',
        component: () => import('../components/viewsCart/Catalogo'),

    }*/,
    {
        name: 'documentoindexview',
        path: '/documentoindexview',
        component: () => import(/* webpackChunkName: "DocumentosIndex" */'../components/DocumentosIndex'),
        meta: { requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'documentocreateview',
        path: '/documentocreateview',
        component: () => import(/* webpackChunkName: "DocumentosCreate" */'../components/DocumentosCreate'),
        meta: { requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'documentoeditview',
        path: '/documentoeditview/:id',
        component: () => import(/* webpackChunkName: "DocumentosEdit" */'../components/DocumentosEdit'),
        meta: { requiresAuth: true, roles: ['admin'] },
    },

    {
        name: 'catalogosview',
        path: '/catalogosview',
        component: () => import(/* webpackChunkName: "Catalogos" */'../components/Catalogos'),
        meta: { title: 'Pdf Catalogos' }
    },

    {
        name: 'catalogoview',
        path: '/catalogoview/:year?/:categoria?',
        component: () => import(/* webpackChunkName: "CatalogoAvance" */'../components/viewsCart/CatalogoAvance'),
        meta: { title: 'Busquedas' }
    },
    {
        name: 'contacto',
        path: '/Contacto',
        component: () => import(/* webpackChunkName: "ContactoEmpresa" */'../components/navegation/ContactoEmpresa'),
        meta: { title: 'Contactanos' }

    },
    {
        name: 'ProdsMX',
        path: '/ProdsMX',
        component: () => import(/* webpackChunkName: "prodmx" */'../components/navegation/prodmx'),
        meta: { title: 'Productos Mexicanos' }
    },
    {
        name: 'OurBrands',
        path: '/OurBrands',
        component: () => import(/* webpackChunkName: "nuestrasmarcas" */'../components/navegation/nuestrasmarcas'),
        meta: { title: 'Nuestras Marcas' }
    },
    {
        name: 'RelMarcaLinea',
        path: '/RelMarcaLinea/:operacion',
        component: () => import(/* webpackChunkName: "RelLinMar" */'../Admin/Productos/RelLinMar'),
        meta: { title: 'Relaciones Categorias', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'UploadFileCar',
        path: '/UploadFileCar',
        component: () => import(/* webpackChunkName: "UploadFileCar" */'../components/viewsCart/UploadFileCar'),
        meta: { title: 'Carga Archivo Cart', requiresAuth: true, },
    },
    {
        name: 'DetallePrepedido',
        path: '/DetallePrepedido',
        component: () => import(/* webpackChunkName: "DetallCotV191220251225" */'../components/navegation/Cotizaciones/DetallCot'),
        meta: { title: 'Aprobación Prepedido', requiresAuth: true },

    },
    {
        name: 'DetallePedidoCreado',
        path: '/DetallePedidoCreado/:sucursal/:folio',
        component: () => import(/* webpackChunkName: "DetallePedidoCreado" */'../components/navegation/Cotizaciones/DetallePedidoCreado'),
        meta: { title: 'Confirmación Prepedido', requiresAuth: true },
    },
    {
        name: 'DetallePrepedidoAuth',
        path: '/DetallePrepedidoAuth',
        component: () => import(/* webpackChunkName: "DetallePedidoAuthV191220251225" */ '../components/navegation/Cotizaciones/DetallePedidoAuth'),
        meta: { title: 'Confirmación Prepedido', requiresAuth: true },
    },
    {
        name: 'Publicaciones',
        path: '/Publicaciones/:id?',
        component: () => import(/* webpackChunkName: "PublicacionForm" */'../components/Documentos/PublicacionForm'),
        meta: { requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'ListBolletin',
        path: '/ListBolletin',
        component: () => import(/* webpackChunkName: "ListBolletin" */'../comunidad/ListBolletin'),
        meta: { title: 'Boletínes' }

    },
    {
        name: 'EditProds',
        path: '/EditProds/:id',
        component: () => import(/* webpackChunkName: "configuracionesEditProdsV161020251323" */'../Admin/configuraciones/EditProds'),
        meta: { requiresAuth: true, roles: ['admin'] },
        meta: { title: 'Editar Producto' }
    },
    {
        name: 'CreateProd',
        path: '/CreateProd',
        component: () => import(/* webpackChunkName: "configuracionesCrateProd" */'../Admin/configuraciones/CrateProd'),
        meta: { title: 'Creación Producto', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'Productos',
        path: '/Productos',
        component: () => import(/* webpackChunkName: "viewprodsV181220251140" */'../Admin/configuraciones/viewprods'),
        meta: { requiresAuth: true },
    },
    {
        name: 'ListPublicaciones',
        path: '/ListPublicaciones',
        component: () => import(/* webpackChunkName: "ListBolletinPublicaciones" */'../comunidad/ListBolletinPublicaciones'),
        meta: { title: 'Index Publicaciónes', requiresAuth: true, roles: ['admin'] },
    }
    ,
    {
        name: 'ListPublicacionesEdit',
        path: '/ListPublicacionesEdit',
        component: () => import(/* webpackChunkName: "ListBolletinPublicacionesEdit" */'../comunidad/ListBolletinPublicacionesEdit'),
        meta: { title: 'Editar Publicación', requiresAuth: true, roles: ['admin'] },
    }
    ,
    {
        name: 'ListBlogs',
        path: '/ListBlogs',
        component: () => import(/* webpackChunkName: "ListPublicacionesClientes" */'../comunidad/ListPublicacionesClientes'),
        meta: { title: 'Publicaciónes' }
    },
    {
        name: 'DetallePost',
        path: '/DetallePosts/:id',
        component: () => import(/* webpackChunkName: "DetallPostClientes" */'../comunidad/DetallPostClientes'),
        meta: { title: 'Detalle Post' }
    },

    //errores
    {
        name: 'unauthorized',
        path: '/unauthorized',
        component: () => import(/* webpackChunkName: "unauthorized" */'../Admin/Errores/unauthorized'),
        meta: { title: 'No autorizado' }
    },
    //vista de mobil
    {
        name: 'mobilsearch',
        path: '/mobilsearch',
        component: () => import(/* webpackChunkName: "mobilsearch" */'../components/navegation/Mobil/mobilsearch'),
        meta: { title: 'Busqueda Movil' }

    }
    ,
    {
        name: 'Correos',
        path: '/Correos',
        component: () => import(/* webpackChunkName: "configuracionescorreo" */'../Admin/configuraciones/configuracionescorreo'),
        meta: { title: 'Config Correos', requiresAuth: true, roles: ['admin'] },

    },
    {
        name: 'DetailsErrosProds',
        path: '/DetailsErrosProds',
        component: () => import(/* webpackChunkName: "adminerrorsproducto" */'../Admin/Errores/adminerrorsproducto'),
        meta: { title: 'List. Error Prods.', requiresAuth: true, roles: ['admin'] },
    }
    ,
    {
        name: 'DetailsErrosCarts',
        path: '/DetailsErrosCarts',
        component: () => import(/* webpackChunkName: "adminerrorscart" */'../Admin/Errores/adminerrorscart'),
        meta: { title: 'List. Error Cart', requiresAuth: true, roles: ['admin'] },
    }
    ,
    {
        name: 'HerramientasClienteCotizador',
        path: '/HelpCotizador',
        component: () => import(/* webpackChunkName: "HelpCotizadorV191220252044" */'../HelpUsers/HelpCotizador'),
        meta: { title: 'Cotizador', requiresAuth: true, roles: ['cliente', 'Cotizador-Mostrador'] },
    },
    {
        name: 'Sync',
        path: '/Sync',
        component: () => import(/* webpackChunkName: "AdminProdsSyncErp" */'../Admin/Productos/AdminProdsSyncErp'),
        meta: { title: 'Sync. Prods.', requiresAuth: true, roles: ['admin'] },
    },
    {
        path: '/busquedaAvanzada',
        name: 'Resultados',
        component: () => import(/* webpackChunkName: "resultadosV020120261628" */'../Home/resultados.vue'),
        props: route => ({
            year: route.query.year,
            marca: route.query.marca,
            modelo: route.query.modelo,
            motor: route.query.motor,
            linea: route.query.linea,
            idBusqueda: route.query.idBusqueda,  // Puede ir null
            tipobusqueda: route.query.tipobusqueda,  // Puede ir null
            activoUsuario: route.query.activoUsuario // Puede ser 1 o 0
        })
    },
     {
        name: 'documentosconsultSat',
        path: '/documentosconsultSat',
        component: () => import(/* webpackChunkName: "DoctosSatV20250826" */'../Admin/configuraciones/DoctosSat.vue'),
        meta: { title: 'Admin Docto Sat.', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'consultdocumentosSat',
        path: '/consultdocumentosSat',
        component: () => import(/* webpackChunkName: "DetalleDocumentosV181220251140" */'../asesores/Clientes/DetalleDocumentos.vue'),
        meta: { title: 'Consulta Doctos Sat.', requiresAuth: true, roles: ['cliente'] },
    },
    {
        path: '/DetalleDocuments',
        name: 'DocumentosDetalle',
        component: () => import(/* webpackChunkName: "DocumentsElectDetalleV20250826" */'../asesores/Clientes/DocumentsElectDetalle.vue'),
        meta: { title: 'Detalle Docto Sat.', requiresAuth: true, roles: ['cliente'] },
    },
    {
        path: '/anunciosadmin',
        name: 'anunciosadmin',
        component: () => import(/* webpackChunkName: "AnuncioPersonalizadoV20250826" */'../Admin/Publicidad/AnuncioPersonalizado.vue'),
        meta: {
            title: 'Administración de Anuncios',requiresAuth: true, roles: ['admin'] 
        }
    },
    {
        path: '/:catchAll(.*)', // Ruta de captura para cualquier ruta no definida
        redirect: '/' // Redirige a la ruta de inicio (Home)
    }
    /*,ProdsMX,OurBrands
    {PruebasProds
        name: 'permissions',
        path: '/posts',
        component: Posts
    }*/

];



const router = createRouter({
    history: createWebHistory(),
    base: '/JACVE/',
    routes: routes,
});


router.beforeEach((to, from, next) => {
    const isAuthenticated = window.Laravel.isLoggedin || false;
    const userRoles = window.Laravel.roles || [];
    const userPermisos = window.Laravel.permissions || [];

    // Verificar si la ruta requiere autenticación
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!isAuthenticated) {
            // Redirige si no está autenticado
            window.location.href = `${window.location.origin}/Ingresa`;
        } else {
            const requiredRoles = to.meta.roles || [];
            const requiredPermisos = to.meta.permisos || [];

            // Excepción para el rol 'admin', siempre tendrá acceso
            if (userRoles.includes('admin')) {
                next();
                return;
            }

            // Verificar si el usuario tiene al menos un rol requerido
            const hasRequiredRoles = requiredRoles.length === 0 || requiredRoles.some(role => userRoles.includes(role));

            // Verificar si el usuario tiene los permisos requeridos
            const hasRequiredPermisos = requiredPermisos.length === 0 || requiredPermisos.every(permiso => userPermisos.includes(permiso));

            // Primero, validar si tiene el rol adecuado (sin importar los permisos)
            if (hasRequiredRoles) {
                // Si tiene el rol requerido, permitir acceso sin importar permisos
                next();
            } else if (hasRequiredPermisos) {
                // Si no tiene el rol pero tiene los permisos, permitir acceso
                next();
            } else {
                // Si no cumple con los requisitos de roles o permisos, redirigir a 'unauthorized'
                next({ name: 'unauthorized' });
            }
        }
    } else {
        // Si la ruta no requiere autenticación, continuar
        if (to.meta && to.meta.title) {
            document.title = to.meta.title;
        }
        next();
    }
});

export default router;
